import React from 'react';
import { Typography, Button, Tag, Tooltip, Alert } from 'antd';
import { LeftOutlined, ReloadOutlined } from '@ant-design/icons';
import { formatInTimezone, formatInUserTime } from '../../../utils/campaign-timezone';

const { Title, Text } = Typography;

const styles = {
    panel: {
        background: '#fff',
        border: '1px solid var(--gh-gray-200, #E6E6E6)',
        borderRadius: 8,
        padding: '8px 10px'
    },
    subText: {
        fontSize: 12,
        color: 'var(--gh-text-secondary, #607D8B)'
    }
};

const CampaignViewHeader = ({ campaignDetails, onBack, onRefresh, extraActions }) => {
    const { uiStatus = {} } = campaignDetails;
    const createdBy = campaignDetails.creator_name || campaignDetails.username || campaignDetails.created_by || '--';
    const creatorTimezone = campaignDetails.creator_timezone || '';
    const createdAtLabel = formatInTimezone(campaignDetails.created_at, creatorTimezone);

    return (
        <div style={styles.panel}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 6 }}>
                <Button
                    size="small"
                    type="text"
                    icon={<LeftOutlined />}
                    onClick={onBack}
                />

                <div style={{ flex: 1, minWidth: 0 }}>
                    <div style={{ display: 'flex', alignItems: 'center', gap: 8, minWidth: 0 }}>
                        <Title
                            level={5}
                            style={{
                                margin: 0,
                                color: 'var(--gh-text-primary, #263238)',
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            {campaignDetails.name}
                        </Title>
                        <Tag color={uiStatus.color} style={{ marginRight: 0, borderRadius: 999 }}>
                            {uiStatus.status || 'Unknown'}
                        </Tag>
                    </div>
                    <Text style={styles.subText}>
                        <Tooltip title={formatInUserTime(campaignDetails.created_at)}>
                            <span>
                                Created {createdAtLabel}{creatorTimezone ? ` (${creatorTimezone})` : ''}
                            </span>
                        </Tooltip>
                    </Text>
                </div>

                <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
                    {extraActions}
                    <Button
                        size="small"
                        icon={<ReloadOutlined />}
                        onClick={onRefresh}
                    >
                        Refresh
                    </Button>
                </div>
            </div>

            {!campaignDetails.hasCampaignBot && (
                <Alert
                    type="warning"
                    showIcon
                    style={{ marginBottom: 8 }}
                    message="No Campaign Bot"
                    description="This campaign has no broadcast campaign bot configured."
                />
            )}
        </div>
    );
};

export default CampaignViewHeader;
